import qs from "qs"

export const makeFilterString = objectIds => {
  const defaultFilters = "current_step:Complete AND tos:true"

  // If too many IDs are passed to the resulting query, a 414 error will occur.
  // Error seems to occur at around 100 IDs. Results are reduced for safety.
  const idsSubset = objectIds?.slice(0, 95)
  const orObjectIds = idsSubset.map(id => `objectID:${id}`).join(" OR ")

  return `${defaultFilters} AND (${orObjectIds})`
}

export const createURL = state => `?${qs.stringify(state)}`

export const makeUrlParams = jobIds => {
  const nextFilters = makeFilterString(jobIds)
  const nextState = {
    configure: {
      filters: nextFilters,
    },
  }
  const urlParams = createURL(nextState)
  return urlParams
}
